import * as React from "react";
import {createElement, useCallback} from "react";
import {MenuItem, TextField} from "@mui/material";
import {TagFragmentSeverity} from "../../domain/TenantUser";
import {useLocalization} from "../../i18n";

interface SeverityInputProps {
    label: string;
    value: TagFragmentSeverity;
    onChange: (severity: TagFragmentSeverity) => void;
}

export function SeverityInput(props: SeverityInputProps) {
    const {label, value, onChange} = props;
    const {e} = useLocalization();

    const handleChange = useCallback((str: string) => {
        onChange(str as TagFragmentSeverity);
    }, [onChange]);

    return (
        <TextField variant="outlined" select fullWidth label={label} value={value}
                   onChange={(e) => handleChange(e.target.value)}>
            {Object.keys(TagFragmentSeverity).map((s) =>
                <MenuItem key={s} value={s}>{e('tenants.tagFragments.severities', s)}</MenuItem>
            )}
        </TextField>
    );
}
